import type { Sections } from './sections'

// What someone uses the app for, for themselves alone ("What I use" in Preferences), under the owner's switches and
// each circle's. Share and see: everything, as usual. Just see: what others share shows as always, but there's no
// "+" to add any. Off: the section leaves their own tabs and Home; links to it still open. Nobody else sees a
// difference, and it never hides what someone shares from anyone.
export const USE_SECTIONS = ['photos', 'moments', 'recipes'] as const
export type UseSection = (typeof USE_SECTIONS)[number]
export const USES = ['post', 'view', 'off'] as const
export type Use = (typeof USES)[number]
export type Uses = Record<UseSection, Use>

export const ALL_POST: Uses = { photos: 'post', moments: 'post', recipes: 'post' }

export const USE_LABELS: Record<Use, string> = { post: 'Share and see', view: 'Just see', off: 'Off' }

// Whether you add things to this section yourself. An older server sends no uses: everything, as before.
export const posts = (uses: Uses | undefined, section: UseSection) => (uses?.[section] ?? 'post') === 'post'

// The sections shown in your own tabs and on Home: the circle's, less the ones you've turned off for yourself.
export const forMe = (sections: Sections, uses: Uses | undefined): Sections => ({
  ...sections,
  ...Object.fromEntries(USE_SECTIONS.map((s) => [s, sections[s] && uses?.[s] !== 'off'])),
})
